import { graphql } from "gql";

const ADMIN_GRANT_HISTORICAL_ACCESS_MUTATION = graphql(`
  mutation AdminGrantHistoricalAccess($distributionGroupId: ID!, $userId: ID!) {
    adminGrantHistoricalAccess(
      distributionGroupId: $distributionGroupId
      userId: $userId
    ) {
      ...DistributionGroup
    }
  }
`);

export default ADMIN_GRANT_HISTORICAL_ACCESS_MUTATION;
